import { FormattedMessage } from 'react-intl'

/**
 * Translation component with support for rich text formatting.
 *
 * Usage:
 *   <Message id="welcome" />
 *   <Message id="greeting" values={{ name: 'John' }} />
 *   <Message id="bold_text" /> // With translation: "This is <bold>important</bold>"
 */
const Message = ({ id, values = {} }) => {
  const richTextValues = {
    ...values,
    bold: (...chunks) => <strong>{chunks}</strong>,
    p: (...chunks) => <p>{chunks}</p>,
    br: () => <br />,
  }

  return <FormattedMessage id={id} values={richTextValues} />
}

export default Message
